import useFeatureFlag, { FeatureFlag } from '../../../hooks/useFeatureFlag';
import { AiCrawlerLineup, AMAZON_LINEUP, GEMINI_LINEUP } from './aiCrawlerLineup';

export function useAiCrawlerLineup(): AiCrawlerLineup {
  return useFeatureFlag([FeatureFlag.AiInsightsAmazonbot]) ? AMAZON_LINEUP : GEMINI_LINEUP;
}
